import _ from 'lodash';
import { default as privateSettings } from './privateSetting.json';

const getAppMode = () => {
    const hostName = window?.location?.hostname;
    if (hostName?.toLowerCase().includes('hearscore360')) {
        return 'demo';
    }
    return 'dev';
};

const getApiUrl = () => {
     // let _apiUrl = 'http://localhost:64412/';
    let _apiUrl = 'https://devdcint.hearscore360.net/';
    const _isProdution = window.location.hostname === 'localhost' ? false : true;
    if (_isProdution) {
        const mode = getAppMode();
        _apiUrl = mode === 'demo' ? `https://devdcint.hearscore360.net/`: `https://devdcint.hearscore360.net/`;
    }
    return _apiUrl;
};

const getAuthToken = () => {
       return `Bearer 3b479a6e-406e-445f-b702-ca9ae0aa1270b5227d78-cbbb-404f-b8ca-97cc3050ed95`;
};

const AppConfig = {
    appMode: getAppMode(), // local or dev or prod
    apiUrl: getApiUrl(), 
    getAuthToken,
    env: function (config) {
        if (this.appMode === 'prod') {
            return this.prod[config];
        }
        else if (this.appMode === 'dev') {
            return this.dev[config];
        }
        else {
            return this.local[config];
        }
    },
    local: {
        deviceType: 'desktop', // 'desktop', 'mobile'
        userId: '1001',
        userKey: 'p1wDEpqqSdslueFexZHl+A==',
        connectionId: (process.env.NODE_ENV === 'development' && privateSettings && privateSettings.MasterConnectionId) ? privateSettings.MasterConnectionId : '',
    },
    dev: {
        deviceType: 'desktop', // 'desktop', 'mobile'
        userId: '',
        userKey: '',
        connectionId: ''
    },
    prod: {
        deviceType: 'desktop', // 'desktop', 'mobile'
        userId: '',
        userKey: '',
        connectionId: ''
    }
}

export default AppConfig;
